import { useContext, useEffect, useState } from 'react'
import Head from 'next/head'
import { PostJobContainer } from '../../commonComponents/PostJobContainer'
import { pageScripts } from '../_app'
import { useRouter } from 'next/router'
import { CircularSpinner } from '@/components/CircularSpinner'
import { AdvertiserContext } from '../../context/AdvertiserContext'
import { SharedContext } from '../../context/SharedContext'
import { fetchDraftContext, fetchSubmission } from '../../services/postJob'
import { isAndroid, isLegacyNewsWebView } from '../../android/bridge'

const AdvertiserPostJob = () => {
  const { cookie, setLanguage } = useContext(SharedContext)

  const {
    setLanguagefromAndriod,
    languageFromAndroid,
    submissionId,
    setSubmissionId
  } = useContext(AdvertiserContext)
  
  const [data, setData] = useState()
  const [hydrated, setHydrated] = useState(false)
  const [loader, setLoader] = useState(true)
  const [isAndroidWebview, setIsAndroidWebview] = useState(false)
  const router = useRouter()

  const fetchData = async () => {
    const language = cookie.get('language') || 'en'
    const location = cookie.get('location') || {}
    const userState = cookie.get('userState')

    const baseParams = {
      location_id: location?.id,
      locale: languageFromAndroid,
      en: 0
    }

    if (userState) baseParams.state_id = userState

    /* ------------------ network requests (new helpers) ------------------- */
    let submissionRes
    try {
      if (submissionId) {
        submissionRes = await fetchSubmission({
          submissionId,
          params: baseParams,
          language,
          isAndroidWebview: isAndroid()
        })
      }

      const draftRes = await fetchDraftContext({
        params: baseParams,
        language: 'en', // always English per product spec
        isAndroidWebview: isAndroid()
      })

      /* ----------------- success path: merge & cache -------------------- */
      setData({
        ...draftRes.data,
        draft_data: submissionId ? submissionRes?.data : draftRes.data?.draft_data
      })
    } finally {
      setLoader(false)
    }
  }

  // News App Android Webview Logic
  useEffect(() => {
    if (isLegacyNewsWebView()) {
      localStorage.setItem('formData', JSON.stringify({}))
      setIsAndroidWebview(true)
      const submissionId = Android.getSubmissionId()
      localStorage.setItem('postJobPresentStep', submissionId != 0 ? 4 : 1)
      if (submissionId != 0) setSubmissionId(submissionId)
      const locale = router?.asPath?.split('locale=')?.[1]
      setLanguagefromAndriod(locale)
      setLanguage('en')
    }
    setHydrated(true)
  }, [])

  useEffect(() => {
    fetchData()
  }, [submissionId])

  if (!hydrated) {
    return pageScripts()
  }

  return (
    <div>
      <Head>
        <title>Lokal: Post your job requirements - get quality job profiles</title>
        <meta name="title" content="Lokal: Post your job requirements - get quality job profiles" />
        <meta
          name="description"
          content="Post your job opening on Lokal for free and reach out to thousands of qualified profiles in your area. Simplify your hiring process and find the best fit for your company today."
        />
        <meta
          property="og:description"
          content="Post your job opening on Lokal for free and reach out to thousands of qualified profiles in your area. Simplify your hiring process and find the best fit for your company today."
        />
        <meta
          property="og:title"
          content="Lokal: Post your job requirements - get quality job profiles"
        />
        <meta
          property="twitter:description"
          content="Post your job opening on Lokal for free and reach out to thousands of qualified profiles in your area. Simplify your hiring process and find the best fit for your company today."
        />
        <meta
          property="twitter:title"
          content="Lokal: Post your job requirements - get quality job profiles"
        />
      </Head>
      {pageScripts()}
      {(!data) && (
        <div className="flex h-[100vh] items-center justify-center backdrop:brightness-0">
          <CircularSpinner />
        </div>
      )}
      {data && (
        <PostJobContainer {...{ data, loader, isAndroidWebview, submissionId, setData }} />
      )}
    </div>
  )
}

export default AdvertiserPostJob
